import {Provider} from '@angular/core';
import {PaginationBaseService} from './pagination-base.service';

export const PROVIDERS: Provider[] = [
  PaginationBaseService,
];
